import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

var customActions = {
  getTeachers: {method: 'GET', url: 'schools{/id}/teachers'},
  saveSchool: {method: 'POST', url: 'schools/faculties'}
}

export const SchoolResource = () => {
  return Vue.resource('schools{/id}', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/school.js